import { Component } from '@angular/core';

@Component({
  selector: 'ngx-quantity-breaks',
  templateUrl: './quantity-breaks.component.html',
  styleUrls: ['./quantity-breaks.component.scss']
})
export class QuantityBreaksComponent {

}
